export default __webpack_public_path__ + "static/media/offlineUsersNotActive.57247993.svg";